import { render, staticRenderFns } from "./BasicsCmp.vue?vue&type=template&id=7392afc5&scoped=true"
import script from "./BasicsCmp.vue?vue&type=script&lang=js"
export * from "./BasicsCmp.vue?vue&type=script&lang=js"
import style0 from "./BasicsCmp.vue?vue&type=style&index=0&id=7392afc5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7392afc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7392afc5')) {
      api.createRecord('7392afc5', component.options)
    } else {
      api.reload('7392afc5', component.options)
    }
    module.hot.accept("./BasicsCmp.vue?vue&type=template&id=7392afc5&scoped=true", function () {
      api.rerender('7392afc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Edit/BasicsCmp.vue"
export default component.exports